import * as React from 'react';
import {
  StackNavigationProp,
  createStackNavigator
} from '@react-navigation/stack';

import { getScreenOptions } from './getScreenOptions';
import MyProfileWearableSettingsScreen from '../screens/my-profile/MyProfileWearableSettingsScreen';
import { H5 } from '../components/Typography';
import { Octicons } from '@expo/vector-icons';
import { useNavigation } from '@react-navigation/native';
import { TouchableOpacity } from 'react-native';

export type ManageWearableParamList = {
  MyProfileWearableSettings: undefined;
};

const ManageWearableStack = createStackNavigator<ManageWearableParamList>();

export default function ManageWearableNavigator() {
  const navigation = useNavigation<StackNavigationProp<any>>();
  return (
    <ManageWearableStack.Navigator
      initialRouteName='MyProfileWearableSettings'
      screenOptions={({ route }) => ({
        ...getScreenOptions(route),
        headerStyle: {
          backgroundColor: '#FDFBF7',
          elevation: 0,
          shadowOpacity: 0,
          borderBottomWidth: 0
        },
        headerLeft: props => (
          <TouchableOpacity
            style={{ marginLeft: 26, width: 30 }}
            onPress={() => {
              if (navigation.canGoBack()) {
                navigation.goBack();
              } else if (!props.canGoBack) {
                const parentNavigation = navigation?.getParent();
                if (!parentNavigation) return;
                const parentCanGoBack = parentNavigation.canGoBack();
                if (!parentCanGoBack) {
                  navigation.reset({
                    index: 0,
                    routes: [
                      {
                        name: 'ToDoNav'
                      }
                    ]
                  });
                } else {
                  parentNavigation.goBack();
                }
              } else {
                props.onPress?.();
              }
            }}
          >
            <Octicons size={30} name='chevron-left' />
          </TouchableOpacity>
        ),
        headerTitle: props => <H5 color='dark'>{props.children}</H5>,
        headerTitleAlign: 'center',
        headerShown: true,
        gestureEnabled: false
      })}
    >
      <ManageWearableStack.Screen
        name='MyProfileWearableSettings'
        component={MyProfileWearableSettingsScreen}
        options={{ title: 'Wearable Integrations' }}
      />
    </ManageWearableStack.Navigator>
  );
}
